// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3kbVZ","title":"AfterFrontImage_title__1YNmW"};